/*
 * https://github.com/5orenso
 *
 * Copyright (c) 2026 Øistein Sørensen
 * Licensed under the MIT license.
 */

/*
 * The cellphone lookup (Strex address lookup, see fields.js `cellphoneLookup`) returns the
 * street address in three separate parts, and any of them may be missing:
 *
 *   - subscriptions of type `Company` often carry a name but no `streetName` at all, and an
 *     empty `streetNumber`. Concatenating those blindly wrote the literal string
 *     "undefined " into visitor.address.
 *   - roughly one in six hits carries a `streetLetter` ("Hestehagen 37 A"), which was
 *     dropped entirely, leaving an incomplete address.
 *
 * So join only the parts that are actually present, and let the caller skip the write when
 * there is nothing to write.
 */

const asText = value => (value === null || value === undefined ? '' : String(value).trim());

export const formatLookupAddress = (response = {}) => {
    const { streetName, streetNumber, streetLetter } = response || {};
    // The letter belongs to the house number ("37 A" is written "37A" as one token).
    const houseNumber = `${asText(streetNumber)}${asText(streetLetter)}`;
    return [asText(streetName), houseNumber]
        .filter(part => part)
        .join(' ');
};

export default { formatLookupAddress };
